import { Component, Input, OnInit } from '@angular/core';
import { ScreenService } from 'src/app/shared/services/screen.service';
import { MedigiComponentCopyService } from '../../medigi/medigi-component-copy.service';

@Component({
  selector: 'app-carousel-static',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  @Input() location = '';
  @Input() type = '';
  carouselIndex = 0;
  carouselSubject = {};
  mobileUser: boolean = false;

  constructor(
    public medigiCopyService: MedigiComponentCopyService,
    public screenSizeService: ScreenService,
  ) {}

  ngOnInit() {
    this.populateCarouselSubject();
    this.checkUserScreenSize();
  }

  checkUserScreenSize() {
    if (
      this.screenSizeService.sizes['screen-small'] ||
      this.screenSizeService.sizes['screen-x-small'] === true
    ) {
      this.mobileUser = true;
    }
  }

  populateCarouselSubject() {
    if (this.location === 'websites') {
      this.carouselSubject =
        this.medigiCopyService.carousels.medigiSitesCarousels;
    } else if (this.type === 'stepcards') {
      if (this.location === 'home') {
        this.carouselSubject = this.medigiCopyService.cards.stepCards.homePage;
      } else if (this.location === 'pharmacy') {
        this.carouselSubject =
          this.medigiCopyService.cards.stepCards.pharmayPage;
      } else if (this.location === 'manufacturer') {
        this.carouselSubject =
          this.medigiCopyService.cards.stepCards.manufacturerPgae;
      }
    }
  }
}
